"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getExampleNumber;

var _PhoneNumber = _interopRequireDefault(require("./PhoneNumber"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getExampleNumber(country, examples, metadata) {
  if (examples[country]) {
    return new _PhoneNumber["default"](country, examples[country], metadata);
  }
}
//# sourceMappingURL=getExampleNumber.js.map


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/build/getExampleNumber.js
// module id = 802
// module chunks = 0